import React from 'react';
import cx from 'classnames';

interface LabelProps {
  top?: boolean;
  bold?: boolean;
  align?: string;
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
}

/** @deprecated - prefer `design-system` (TextInput and Select components have built-in `label` props) */
const Label: React.FC<LabelProps> = ({ top, bold, align = 'left', style, className, children }) => {
  const labelClass = cx(align, { bold, top });

  return (
    <label className={className || labelClass} style={style}>
      {children}
      <style jsx>{`
        label {
          font-weight: normal;
          font-size: 0.9rem;
          line-height: 2.2;
          display: block;
          cursor: pointer;
        }
        label.left {
          text-align: left;
        }
        label.right {
          text-align: right;
        }
        label.bold {
          font-weight: bold;
        }
        label.top {
          align-self: start;
        }
      `}</style>
    </label>
  );
};

export default Label;
